module.exports = __webpack_public_path__ + "static/dockside-blue-15afdc4b08435060f689182be5bc5050.png";